import { BookOpen, Factory, Package, PackageCheck, Layers3, Wheat } from '@/components/icons';

export const ENTITY_STYLES = {
  recipe: {
    label: 'Ricetta',
    icon: BookOpen,
    text: 'text-blue-700',
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    accent: 'border-l-blue-600'
  },
  batch: {
    label: 'Produzione',
    icon: Factory,
    text: 'text-blue-700',
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    accent: 'border-l-blue-600'
  },
  lot: {
    label: 'Lotto',
    icon: Package,
    text: 'text-slate-700',
    bg: 'bg-slate-50',
    border: 'border-slate-200',
    accent: 'border-l-slate-400'
  },
  product: {
    label: 'Prodotto',
    icon: PackageCheck,
    text: 'text-slate-700',
    bg: 'bg-slate-50',
    border: 'border-slate-200',
    accent: 'border-l-slate-400'
  },
  semifinished: {
    label: 'Semilavorato',
    icon: Layers3,
    text: 'text-blue-700',
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    accent: 'border-l-blue-600'
  },
  ingredient: {
    label: 'Ingrediente',
    icon: Wheat,
    text: 'text-slate-700',
    bg: 'bg-slate-50',
    border: 'border-slate-200',
    accent: 'border-l-slate-400'
  }
};

export const entityForProductType = (type) => {
  if (type === 'semifinished') return 'semifinished';
  if (type === 'final_product') return 'product';
  return 'lot';
};
